import styled from "styled-components";

export const Root = styled.div`
  padding: 152px 0;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding: 245px 0;
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    padding: 259px 0;
  }
`;

export const WrapperForGatsbyImage = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
